<template>
  <CircleSpinner v-if="loading" />
  <RouterView v-else :event="event" :product-categories="productCategories" :kiosk="kiosk" :extras-orders="extrasOrders" />
</template>

<script setup lang="ts">
import { CircleSpinner } from '@ramp106/omrjs-core-ui'
import { computed } from 'vue'

import { useExtrasOrdersQuery, useFestivalShopProductCategoriesQuery, type Event, type KioskUnion } from '@/gql/myomr'
import type { ExtrasOrderNode } from '@/views/FestivalShop'

const props = defineProps<{
  event: Event
  kiosk: KioskUnion
}>()
const rootEventSlug = computed(() => props.event.rootEvent?.slug ?? props.event.slug ?? '')

const { result: extrasOrdersResult, loading: extrasOrdersLoading } = useExtrasOrdersQuery(
  () => ({
    rootEvent: { slug: rootEventSlug.value },
    kioskFilter: { id: props.kiosk.id },
  }),
  () => ({
    fetchPolicy: 'cache-and-network',
  }),
)
const { result: productCategoriesResult, loading: productCategoriesLoading } = useFestivalShopProductCategoriesQuery(() => ({
  kioskId: props.kiosk.id,
}))
const loading = computed(() => extrasOrdersLoading.value || productCategoriesLoading.value)
const productCategories = computed(() => productCategoriesResult.value?.festivalShopProductCategories?.nodes ?? [])

const extrasOrders = computed<ExtrasOrderNode[]>(() => extrasOrdersResult.value?.extrasOrders?.nodes ?? [])
</script>
